'use strict';

function hasNoChildren(node) {
    return !node || !node.children || node.children.isEmpty;
}

function isNodeChildrenList(node, list) {
    return node !== null && node.children === list;
}

exports.hasNoChildren = hasNoChildren;
exports.isNodeChildrenList = isNodeChildrenList;
